import { TopBarOptionItem, TopBarOptionItemProps } from './TopBarOptionItem';

interface Option<TId extends string | number> extends Omit<TopBarOptionItemProps, 'onClick' | 'selected' | 'total'> {
    id: TId;
}

export interface InsightsTopBarProps<TId extends string | number> {
    options: Option<TId>[];
    selectedOption: TId;
    totalInsightsAmount: number;
    onOptionClick: (optionId: TId) => void;
}

const InsightsTopBar = <TId extends string | number>({
    options,
    selectedOption,
    totalInsightsAmount,
    onOptionClick
}: InsightsTopBarProps<TId>) => {
    return (
        <div className="px-2 py-1 border-b border-sf-gray-100 flex gap-2">
            {options.map(({ id, ...optionItemProps }) => (
                <TopBarOptionItem
                    key={id}
                    onClick={() => onOptionClick(id)}
                    selected={id === selectedOption}
                    total={totalInsightsAmount}
                    {...optionItemProps}
                />
            ))}
        </div>
    );
};

export default InsightsTopBar;
